/**
 * Funnel tracking helper for the app side.
 *
 * Pushes events onto window.dataLayer. GTM (GTM-TGHVGDB2) loads only on the
 * production host after analytics-cookie consent (see ./analytics.ts); until
 * then events queue in dataLayer and are consumed once GTM initialises.
 */
declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
  }
}

export interface TrackProps {
  [key: string]: string | number | boolean | undefined;
}

export function track(event: string, props: TrackProps = {}): void {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer ?? [];
  window.dataLayer.push({ event, ...props });
}

const FIRST_INVOICE_FLAG = 'bill-alps:has-created-invoice';

export function isFirstInvoice(): boolean {
  if (typeof window === 'undefined') return false;
  return localStorage.getItem(FIRST_INVOICE_FLAG) !== '1';
}

export function markFirstInvoiceFired(): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(FIRST_INVOICE_FLAG, '1');
}
